import { useState, useEffect } from 'react';
import { ColProps } from 'antd/lib/col';
import { sizeType } from '../subpage/baseDetailPage';

interface IRender {
  lineNumber?: number;
  labelCol?: ColProps;
}

function getLineNumber(size: sizeType): number {
  if (size === 'small') return 2;
  if (size === 'middle') return 3;
  if (size === 'large') return 4;
  return 4;
}

function useLineNumber(
  size?: sizeType,
  defaultLineNumber?: number,
  defaultLabelCol?: ColProps,
): IRender {
  const [lineNumber, setLineNumber] = useState<number | undefined>(
    defaultLineNumber,
  );
  useEffect(() => {
    if (size && !defaultLineNumber) setLineNumber(getLineNumber(size));
  }, [size]);
  return { lineNumber, labelCol: { span: 8, ...defaultLabelCol } };
}

export default useLineNumber;
